import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import type { Appearance } from 'view/common/card-link';
import { CardLink } from 'view/common/card-link';
import messages from './messages';
import { MessageContainer } from './styled';

interface RaiseRequestLinkProps {
    to: string;
    className?: string;
    appearance?: Appearance;
    isEmbeddedRoute?: boolean;
}

const RaiseRequestLink: React.FunctionComponent<RaiseRequestLinkProps> = ({ to, isEmbeddedRoute, ...props }) => (
    <CardLink
        to={to}
        padding={0}
        actionSubjectId="requestCreateLink"
        target={isEmbeddedRoute ? '_blank' : undefined}
        {...props}
    >
        <MessageContainer>
            <FormattedMessage {...messages.raiseRequestText} />
        </MessageContainer>
    </CardLink>
);

export default RaiseRequestLink;
